import HttpService from "@/utils/httpData"

export const getDataSubportFilter = id => {
    let apiEndpoint = `library/filter-data?classId=${id}`
    return HttpService.get(apiEndpoint).then(res => {
        return res.data ? res.data : null
    }).catch(e => { return false })
}

export const getLessonsPlan = params => {
    let apiEndpoint = `library/list-lesson-plan`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null
    }).catch(e => { return false })
}

export const getLessonOld = id => {
    let apiEndpoint = `library/detail-lesson-plan?id=${id}`;
    return HttpService.get(apiEndpoint).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false })
}

export const apiUpdateCountdownload = id => {
    let apiEndpoint = `library/update-countdownload?id=${id}`;
    return HttpService.get(apiEndpoint).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const apiUpdateCountdownloadActiveLesson = id => {
    let apiEndpoint = `library/update-download-active-lesson?id=${id}`
    return HttpService.get(apiEndpoint).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const getLesson = id => {
    let apiEndpoint = `library/detail?id=${id}`;
    return HttpService.get(apiEndpoint).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const updatecountview = id => {
    let apiEndpoint = `lesson/update-countview?id=${id}`;
    return HttpService.get(apiEndpoint).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}


export const getMediaListInLibs = params => {
    let apiEndpoint = `library/list-document-type`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const getListActiveLearningAll = params => {
    let apiEndpoint = `library/list-active-learning`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}


export const getListActiveLearningHome = params => {
    let apiEndpoint = `library/list-active-learning-home`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const getMediaDetailInLibs = id => {
    let apiEndpoint = `library/GetBookPageLink?id=${id}`;
    return HttpService.get(apiEndpoint).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const getDetailActiveLearning = id => {
    let apiEndpoint = `library/GetActiveLearning?id=${id}`;
    return HttpService.get(apiEndpoint).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const getMediaRelateInLibs = params => {
    let apiEndpoint = `library/GetListReferentBookPageLink`;
    return HttpService.get(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const getListReferentAtvLearn = params => {
    let apiEndpoint = `library/GetListReferentActiveLearning`;
    return HttpService.get(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const getAllTypeFilter = params => {
    let apiEndpoint = `library/filter-library`;
    return HttpService.get(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const getLibrariesData = payload => {
    let apiEndpoint = `library/list-document-type`;
    return HttpService.post(apiEndpoint, payload).then(res => {
        return res && res.data && res.data.data && !res.data.errors ? res.data.data : null;
    }).catch(e => { return false });
}

export const getLibrariesLessons = payload => {
    let apiEndpoint = `library/list-lesson-plan`;
    return HttpService.post(apiEndpoint, payload).then(res => {
        return res && res.data && res.data.data && !res.data.errors ? res.data.data : null;
    }).catch(e => { return false });
}

export const getListBookActiveLearning = payload => {
    let apiEndpoint = `library/list-book-active-learning`;
    return HttpService.post(apiEndpoint, payload).then(res => {
        return res && res.data && res.data.data && !res.data.errors ? res.data.data : null;
    }).catch(e => { return false });
}

export const getBookFilterPageLinks = params => {
    let apiEndpoint = `Book/LibraFilter`;
    return HttpService.get(apiEndpoint, params).then(res => {
        return res && res.data && res.data.data && !res.data.errors ? res.data.data : null;
    }).catch(e => { return false });
}

export const getBookFilterLesson = params => {
    let apiEndpoint = `Book/LessonFilter`;
    return HttpService.get(apiEndpoint, params).then(res => {
        return res && res.data && res.data.data && !res.data.errors ? res.data.data : null;
    }).catch(e => { return false });
}

export const getReadMoreLinkTypes = params => {
    let apiEndpoint = `library/detailNotiGroup`;
    return HttpService.get(apiEndpoint, params).then(res => {
        return res && res.data && res.data.data && !res.data.errors ? res.data.data : null;
    }).catch(e => { return false });
}

// Share media
export const saveLogShareSocial = payload => {
    let apiEndpoint = `Book/LogShare-Create`;
    return HttpService.post(apiEndpoint, payload).then(res => {
        return res && res.data && res.data.data && !res.data.errors ? res.data.data : null;
    }).catch(e => { return false });
}

export const shareSocialByMail = payload => {
    let apiEndpoint = `SendMailShare`;
    return HttpService.post(apiEndpoint, payload).then(res => {
        return res && res.data && !res.data.errors ? res.data : null;
    }).catch(e => { return false });
}

export const getCategoriesByBookLib = id => {
    let apiEndpoint = `practice/get-book-index-pagelink?bookId=${id}`;
    return HttpService.get(apiEndpoint).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const downloadMultiLessonFile = id => {
    let apiEndpoint = `lesson/DownloadFullLesonPlanFileByLessionPalnId?id=${id}`;
    return HttpService.get(apiEndpoint).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const delFileZipLesson = name => {
    let apiEndpoint = `lesson/DeleteFileByName?namefile=${name}`;
    return HttpService.get(apiEndpoint).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}
